class VendorEntity {
  id: number;
  nama: string;
  deskripsi: string;

  constructor(object: {
    id: number;
    nama: string;
    deskripsi: string;
  }) {
    this.id = object.id;
    this.nama = object.nama;
    this.deskripsi = object.deskripsi;
  }
}

class AddVendorEntity {
  nama?: string;
  deskripsi?: string;

  constructor(object: {
    nama?: string;
    deskripsi?: string;
  }) {
    this.nama = object.nama;
    this.deskripsi = object.deskripsi;
  }
}

export { VendorEntity, AddVendorEntity };